import React from 'react';
import { IImage } from '@sapientpro/sapientpro-data-models';
import Img from '../../../components/Img';
import styles from './Article.module.scss';

const ArticleImage = ({ image, title }: { image: IImage, title: string }) => (
  <figure className={styles.imageBlock}>
    <div className={styles.image}>
      <Img
        width={image.width}
        height={image.height}
        src={image.url}
        alt={title || 'article image'}
        withPreloader
      />
    </div>
    {title && <figcaption>{title}</figcaption>}
  </figure>
);

export default ArticleImage;
